<script lang="ts">
  import {cn} from 'Catalyst/cn';
  import 'Catalyst/main.css';
  import 'Catalyst/tailwind.css';
  import {ThemeContext} from 'Catalyst/components/ThemeContext';
  import type {BrandColor, CssColor} from 'Catalyst/utility/theme';

  export let brandColors: BrandColor[] = undefined;
  export let brandColor: CssColor = undefined;
  export let backgroundColor: CssColor = undefined;

  $: klass = $$restProps.class;
</script>

<ThemeContext {brandColors} {brandColor} {backgroundColor}>
  <div {...$$restProps} class={cn('catalyst-app', klass)}>
    <slot />
  </div>
</ThemeContext>
